export default {
  SYSTEM_LIST (state, value) {
    state.systemList = value
  },
  CLIENT_LIST (state, value) {
    state.clientList = value
  },
  CURRENT (state, value) {
    if (value) {
      state.current.id = value.id
      state.current.name = value.name
      state.current.backups = value.backups
    } else {
      state.current = {
        id: '',
        name: '',
        backups: []
      }
    }
  },
  SYSTEM_LIST_REMOVE (state, value) {
    const index = state.systemList.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.systemList.splice(index, 1)
    }
  },
  CLIENT_LIST_REMOVE (state, value) {
    const index = state.clientList.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.clientList.splice(index, 1)
    }
  }
}
